import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext.jsx';
import { MdArrowBackIos, MdClose, MdDateRange, MdFileDownload, MdHistory, MdReport, MdSearch } from "react-icons/md"; 
import { Timestamp } from "firebase/firestore"; 
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";
 
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Cash_books_statement() {
     const servicetablename = "accountingfinancedb";
    const [IsLoading2, setIsLoading2] = useState(true);
    const { Toastshow } = Toast();
    const [amount, setAmount] = useState(0);
    const [transaction, setTransaction] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [voucherlist, setVoucherlist] = useState([]);
    const [oucherselected, setoucherselected] = useState("All Reports");
    const [reportsrata, setReportsData] = useState([]);
    const navigate = useNavigate();
    const [accountguid, setaccountguid] = useState("");
    const [from_date, setFrom_date] = useState("");
    const [to_date, setTo_date] = useState("");
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("accountguid");
        if (uid) {
            setaccountguid(uid);
        } else {
            //  navigate(-1);
        }
    }, [window.location.search]);
    useEffect(() => {
        const today = new Date();

        const firstDay =
            today.getFullYear() +
            "-" +
            String(today.getMonth() + 1).padStart(2, "0") +
            "-01";

        const currentDay = today.toISOString().slice(0, 10);

        setFrom_date(firstDay);
        setTo_date(currentDay);
    }, []);

    const select_company_uid = Cookies.get("select_company_uid");


    const get_Reports = () => {

        setIsLoading2(true);

        if (!select_company_uid) {
            setIsLoading2(false);
            return;
        }

        if (!from_date || !to_date) return;

        const startTimestamp = Timestamp.fromDate(new Date(from_date + "T00:00:00"));
        const endTimestamp = Timestamp.fromDate(new Date(to_date + "T23:59:59"));
        let productQuery = null;

        productQuery = query(
            collection(db, servicetablename, select_company_uid, "cash_books_accounting"),
            where("accountguid", "==", accountguid),
            where("date_time", ">=", startTimestamp),
             where("date_time", "<=", endTimestamp),
           orderBy("date_time", "desc")
        );


        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                // calculate total
                let total = 0, trans = 0;
                vouchers.forEach((v) => {
                    total += Number(v?.totalamount || 0);
                    trans++;

                });
                // vouchers.forEach((v) => {
                //     setVoucherlist((prevList) => {
                //         if (v?.voucher && !prevList.includes(v.voucher)) {
                //             return [...prevList, v.voucher];
                //         }
                //         return prevList;
                //     });
                // });

                setAmount(total);
                setTransaction(trans);
                setReportsData(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();

    }
    useEffect(() => {
        get_Reports();
    }, [select_company_uid,  from_date, to_date]);


    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const formatDMY = (input) => {
        const date =
            input instanceof Date
                ? input
                : input?.toDate
                    ? input.toDate()
                    : new Date(input);

        if (isNaN(date)) return "--";

        const d = String(date.getDate()).padStart(2, "0");
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const y = date.getFullYear();

        return `${d}/${m}/${y}`;
    };
    const downloadPDF = () => {
        if (!reportsrata || reportsrata.length === 0) return;

        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Function to draw header, top line, and footer
        const drawHeaderAndFooter = (data) => {
            // Top full-width line
            // doc.setDrawColor(0); // Black color
            // doc.setLineWidth(0.5);
            // doc.line(14, 12, pageWidth - 14, 12);

            // Title
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.text("Cash books", 14, 15);

            // Date (right side)
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            const dateText = "Date: " + new Date().toLocaleString();
            const textWidth = doc.getTextWidth(dateText);
            doc.text(dateText, pageWidth - textWidth - 16, 15);
            doc.setFont("helvetica", "normal");
            //  const Amounttext = "Amount: " + amount +"/-";

            const Transactiontext = "from: " + formatDMY(from_date) + " To: " + formatDMY(to_date);
            doc.setFontSize(9);
            doc.text(Transactiontext, pageWidth - textWidth - 16, 20);
            //


            // doc.text(Amounttext, pageWidth - textWidth - 14, 23);

            // Bottom line above footer
            doc.setLineWidth(0.1);
            doc.line(14, pageHeight - 18, pageWidth - 14, pageHeight - 18);

            // Page number (center bottom)
            const pageNum = `Page ${doc.internal.getNumberOfPages()}`;
            doc.setFontSize(8);
            doc.text(pageNum, pageWidth / 2, pageHeight - 14, { align: "center" });

            // Footer text (Supported by: Aooz.in)
            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text("Supported by: Aooz.in", pageWidth / 2, pageHeight - 8, { align: "center" });
        };

        // Table Data
        const tableData = reportsrata.map((row) => [
            row.tokennumber || "",
            row.voucherid || "",
            row.date_time?.toDate?.().toLocaleString() || "",
            row.voucher_type || "",
            row.particulars || "",
            row.credit === 0 || row.credit == null ? "--" : Number(row.credit).toFixed(2),
            row.debit === 0 || row.debit == null ? "--" : Number(row.debit).toFixed(2)
        ]);

        // AutoTable with multiple pages
        autoTable(doc, {
            startY: 25,
            head: [["Token","Voucher Id", "Date & Time", "Voucher", "Particulars", "Credit", "Debit"]],
            body: tableData,
            headStyles: {
                fillColor: [37, 99, 235],
                textColor: 255,
                fontStyle: "bold"
            },
            alternateRowStyles: {
                fillColor: [244, 245, 248]
            },
            styles: {
                font: "helvetica",
                fontSize: 9
            },
            columnStyles: {
                4: { halign: "right" } // Right-align Amount
            },

            didDrawPage: drawHeaderAndFooter
        });

        const filename = `Cash_books_${new Date().toLocaleString().replace(/[/, ]/g, "_")}.pdf`;
        doc.save(filename);

    };
    const openEditVoucher = (uid) => {
        navigate(`?page=voucher_read&uid=${uid}`);   // update URL

    };
    return (
        <div >
            <div className="items-back">
                <div className="b-bottom">
                    <table>
                        <tr>
                            <td ><div
                                onClick={() => navigate("/accounting?page=cash_books")}
                                className="button-ui0 text-h2 bold p-2 cursor"
                            >
                                <MdArrowBackIos className="icon" />Cash books statement
                            </div></td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/accounting")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className="post-container p-2">
                    <div className="ui-grid-4-equal">
                        <div className="ui-items">
                            < Ledger_accounts_profile accountguid={accountguid} />
                        </div>

                        
                        <div className="ui-items m-top">
                            {/* <select className="text-h2 bold" onChange={(e) => setoucherselected(e.target.value)}>
                                <option>All Reports</option>
                                {voucherlist.map((item, index) => (
                                    <option key={index} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select> */}
                            <table>

                                <tr>

                                    <td>  <div className="text-h2 bold">Transaction: {transaction}</div></td>
                                    <td width={120}>  <div className="button-ui2 p-1" onClick={downloadPDF}>

                                        <MdFileDownload className="icon cursor" />PDF Download
                                    </div></td>
                                </tr>

                            </table>

                        </div>
                        <div className="ui-items">

                            <table>
                                <tr>
                                    <td>
                                        <input
                                            value={from_date}
                                            type="date"
                                            onChange={(e) => setFrom_date(e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <input
                                            value={to_date}
                                            type="date"
                                            onChange={(e) => setTo_date(e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <div onClick={() => get_Reports()} className="button-ui2 p-1">
                                            <MdSearch className="icon cursor" />
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                </div>
                <div className="post-container p-2"> 
                    <div className="post_div">
                        <div className="ui-grid-fill">

                            {IsLoading2 ? (
                                <></>
                            ) : reportsrata.length === 0 ? (
                                <div className="text-h2 bold p-5">No oucher Found</div>
                            ) : (
                                <>
                                    {window.innerWidth > 768 ? (
                                        // ============================
                                        // DESKTOP VIEW: Single Row Table
                                        // ============================
                                        <table className="voucher-table-desktop ">
                                            <thead>
                                                <tr>
                                                    <th>Token</th>
                                                    <th>VoucherId</th>
                                                    <th>Date & Time</th>
                                                    <th>Voucher</th>
                                                    <th>Particulars</th>
                                                    <th className="text-r">Credit</th>
                                                    <th className="text-r">Debit</th>
                                                          <th className="text-r">Balance</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {reportsrata.map((row) => (

                                                    <tr title="Click" key={row.cashid} className="hover">

                                                        
                                                          <td width={30} className="text-h2">{row.tokennumber || "0"} </td>
                                                        <td width={30} className="text-h3">{row.voucherid || "0"}</td> 
                                                        <td width={130} className="text-h3">
                                                            {row.date_time?.toDate ? (
                                                                <>
                                                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                "No date"
                                                            )}
                                                        </td>
                                                        <td className="text-h2 fcap">{row.voucher_type || "N/A"}</td>
                                                        <td className="text-h2 fcap">{row.particulars || "N/A"}</td>

                                                        <td
                                                            width={80}
                                                            className="text-h2 text-r"
                                                            style={{ color: row.credit === 0 ? "#999" : "" }}
                                                        >
                                                            {row.credit === 0 || row.credit === undefined ? "--" : row.credit.toFixed(2)}
                                                        </td>
                                                        <td
                                                            width={80}
                                                            className="text-h2 text-r"
                                                            style={{ color: row.debit === 0 ? "#999" : "" }}
                                                        >
                                                            {row.debit === 0 || row.debit === undefined ? "--" : row.debit.toFixed(2)}
                                                        </td>
                                                         <td
                                                            width={80}
                                                            className="text-h2 text-r bold"
                                                            style={{ color: row.balance === 0 ? "#999" : "" }}
                                                        >
                                                            {row.balance === 0 || row.balance === undefined ? "--" : row.balance.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                    ) : (
                                        // ============================
                                        // MOBILE VIEW: Card UI
                                        // ============================
                                        reportsrata.map((row) => (
                                            <div
                                                className="ui-items items-back items-back p-11 shadow hover rounded cursor"
                                                onClick={() => openEditVoucher(row.voucherid)}
                                                key={row.ledgerid}
                                            >
                                                <table key={row.id}>
                                                    <tbody>
                                                        <tr>
                                                            <table>
                                                                <tr> <td>
                                                                    <div className="text-h1 bold fcap">
                                                                        {row.voucher || "voucher No found"}
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                                <tr> <td>
                                                                    <table>
                                                                        <tr>
                                                                            <td> <div className="text-h2 fcap bold">
                                                                                {row.namepaying || "No  found"}
                                                                            </div></td>
                                                                            <td className="text-r text-h2">{row.code}{row.mobile || " N/A"}</td>
                                                                        </tr>
                                                                    </table>

                                                                </td>
                                                                </tr>
                                                                <tr> <td>

                                                                    <table className="b-top">
                                                                        <tr>
                                                                            <td>
                                                                                <div className="text-h3">
                                                                                    Token #{row.tokennumber || "0"}
                                                                                </div>
                                                                            </td>
                                                                            <td width={140} className='text-h3 text-r'>
                                                                                {row.date_time?.toDate ? (
                                                                                    <>
                                                                                        {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                                        {row.date_time.toDate().toLocaleTimeString()}
                                                                                    </>
                                                                                ) : (
                                                                                    <div className='contact-details'>No date</div>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    </table>

                                                                </td>
                                                                </tr>
                                                                <tr> <td>

                                                                    <table className="b-top">
                                                                        <tr>

                                                                            <td>
                                                                                <div className="text-h2 bold">
                                                                                    ₹{row.amount || "0"} /-
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="text-h3 text-r">
                                                                                    ID: {row.voucherprintid || "0"}
                                                                                </div>
                                                                            </td>

                                                                        </tr>
                                                                    </table>

                                                                </td>
                                                                </tr>

                                                            </table>



                                                        </tr>
                                                    </tbody>
                                                </table>


                                            </div>
                                        ))
                                    )}
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
